import { defineComponent, computed } from "vue";
export default defineComponent({
  name: "Recharge",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    let overlayShow = computed({
      set(val) {
        return context.emit("update:open", val);
      },
      get() {
        return props.show;
      }
    });
    return {
      overlayShow
    };
  }
});